export const portCodes = {
    CNSHA: '上海',
    CNTAO: '青岛',
    CNXMN: '厦门',
    CNSHK: '蛇口',
    CNYTN: '盐田',
    CNCWN: '赤湾',
    CNDCW: '大铲湾',
    CNHUA: '黄埔',
    CNNSA: '南沙',
}
export const ports = [
    {
      label:'上海',
        value:'CNSHA'
    },
    {
        label:'青岛',
        value:'CNTAO'
    },
    {
        label:'厦门',
        value:'CNXMN'
    },
    {
        label:'蛇口',
        value:'CNSHK'
    },
    {
        label:'盐田',
        value:'CNYTN'
    },
    {
        label:'赤湾',
        value:'CNCWN'
    },
    {
        label:'大铲湾',
        value:'CNDCW'
    },
    {
        label:'黄埔',
        value:'CNHUA'
    },
    {
        label:'南沙',
        value:'CNNSA'
    },
]
export const serviceArea={
    allPorts:[
        {
            vesselName:"ACL-大西洋箱运",
            ports:'全口岸'
        },
        {
            vesselName:"ALIANCA-亚利安莎航运",
            ports:'全口岸'
        },
        {
            vesselName:"ANL—澳航",
            ports:'全口岸'
        },
        {
            vesselName:"CMA—达飞",
            ports:'全口岸'
        },
        {
            vesselName:"CNC—正利",
            ports:'全口岸'
        },
        {
            vesselName:"COSCO—中远海",
            ports:'全口岸'
        },
        {
            vesselName:"DAL—DAL船公司",
            ports:'全口岸'
        },
        {
            vesselName:"GOLD STAR—以星",
            ports:'全口岸'
        },
        {
            vesselName:"GOLDEN SEA—新鑫海航运",
            ports:'全口岸'
        },
        {
            vesselName:"HLC/HPL—赫伯罗特",
            ports:'全口岸'
        },
        {
            vesselName:"HMM—现代",
            ports:'全口岸'
        },
        {
            vesselName:"HSD/HAM—汉堡南美",
            ports:'全口岸'
        },
        {
            vesselName:"MAT—美森轮船",
            ports:'全口岸'
        },
        {
            vesselName:"MCC/SEALAND—海陆马士基",
            ports:'全口岸'
        },
        {
            vesselName:"MSC—地中海",
            ports:'全口岸'
        },
        {
            vesselName:"MSK—马士基",
            ports:'全口岸'
        },
        {
            vesselName:"NDS—尼罗河航运",
            ports:'全口岸'
        },
        {
            vesselName:"ONE—海洋网联",
            ports:'全口岸'
        },
        {
            vesselName:"OOCL-东方海外",
            ports:'全口岸'
        },
        {
            vesselName:"PANASIA—泛亚航运",
            ports:'全口岸'
        },
        {
            vesselName:"WHL—万海航运",
            ports:'全口岸'
        },
        {
            vesselName:"全口岸YML-阳明",
            ports:'全口岸'
        },
        {
            vesselName:"PANASIA—泛亚航运",
            ports:'全口岸'
        },
        {
            vesselName:"ZIM—以星",
            ports:'全口岸'
        },
        {
            vesselName:"PIL—太平船务",
            ports:'全口岸'
        },
        {
            vesselName:"SML-森罗",
            ports:'全口岸'
        },
    ],
    shanghai:[
        {
            vesselName:"CL-中通海运",
            ports:'上海口岸'
        },
        {
            vesselName:"COH-京汉船务",
            ports:'上海口岸'
        },
        {
            vesselName:"CP-中波船代",
            ports:'上海口岸'
        },
        {
            vesselName:"FSC/FESCO-俄远东轮船",
            ports:'上海口岸'
        },
        {
            vesselName:"IAL—运达航运",
            ports:'上海口岸'
        },
        {
            vesselName:"JJ—锦江航运",
            ports:'上海口岸'
        },
        {
            vesselName:"JRCW—璟荣船务",
            ports:'上海口岸'
        },
        {
            vesselName:"KKC—神原汽船",
            ports:'上海口岸'
        },
        {
            vesselName:"NOS—新东海运",
            ports:'上海口岸'
        },
        {
            vesselName:"NZL—新西兰海运",
            ports:'上海口岸'
        },
        {
            vesselName:"PEL—帕尔玛海运",
            ports:'上海口岸'
        },
        {
            vesselName:"PMA—普洱马海运",
            ports:'上海口岸'
        },
        {
            vesselName:"RPS-日照港海运",
            ports:'上海口岸'
        },
        {
            vesselName:"SCI—印度国航",
            ports:'上海口岸'
        },
        {
            vesselName:"SCO—海运船务",
            ports:'上海口岸'
        },
        {
            vesselName:"SOF—顺发航运",
            ports:'上海口岸'
        },
        {
            vesselName:"SSL—萨姆达拉",
            ports:'上海口岸'
        },
        {
            vesselName:"TJM—天津津海",
            ports:'上海口岸'
        },
        {
            vesselName:"TNC—台航",
            ports:'上海口岸'
        },
        {
            vesselName:"ALX-阿拉丁航运",
            ports:'上海口岸'
        },
        {
            vesselName:"RCC-俄集运",
            ports:'上海口岸'
        },
        {
            vesselName:"JRCW-璟荣船务",
            ports:'上海口岸'
        },
        {
            vesselName:"GZZH-广州中航",
            ports:'上海口岸'
        },
        {
            vesselName:"XMYY-厦门远洋",
            ports:'上海口岸'
        },
        {
            vesselName:"UNL-联合航运",
            ports:'上海口岸'
        },
        {
            vesselName:"STAROCEAN MARINE",
            ports:'上海口岸'
        },
        {
            vesselName:"SWIRE-太古",
            ports:'上海口岸'
        },
        {
            vesselName:"WSC-西海航运",
            ports:'上海口岸'
        },
        {
            vesselName:"GMD-联合航运有限公司（越南）",
            ports:'上海口岸'
        },
        {
            vesselName:"ZGXL-上海中谷物流公司",
            ports:'上海口岸'
        },
        {
            vesselName:"FSL-星洋船务",
            ports:'上海口岸'
        },
        {
            vesselName:"SWL-海陆船务",
            ports:'上海口岸'
        },
        {
            vesselName:"HLD-海隆达",
            ports:'上海口岸'
        }

    ],
    outerPort:[
        {
            vesselName:"ASL-亚海",
            ports:'上海，蛇口，赤湾'
        },
        {
            vesselName:"CUL-中联航运",
            ports:'上海，蛇口，赤湾，盐田，南沙'
        },
        {
            vesselName:"DYS-东映商船",
            ports:'蛇口，大铲湾，赤湾，盐田'
        },
        {
            vesselName:"DJS-东进",
            ports:'蛇口，大铲湾，赤湾'
        },
        {
            vesselName:"HAL-兴亚船务",
            ports:'上海，蛇口，大铲湾，赤湾'
        },
        {
            vesselName:"HSL-韩星海运",
            ports:'赤湾'
        },
        {
            vesselName:"KMT—高丽海运",
            ports:'上海，蛇口，大铲湾，赤湾，盐田'
        },
        {
            vesselName:"KWL-建华海运",
            ports:'蛇口，赤湾'
        },
        {
            vesselName:"MEL—玛利亚娜",
            ports:'上海，蛇口，赤湾，盐田'
        },
        {
            vesselName:"NSL—南星海运",
            ports:'海，蛇口，大铲湾，赤湾，盐田'
        },
        {
            vesselName:"RCL—宏海箱运",
            ports:'上海，蛇口，大铲湾，赤湾，盐田，南沙'
        },
        {
            vesselName:"SLS—海领船务",
            ports:'上海，蛇口，大铲湾，赤湾，南沙'
        },
        {
            vesselName:"SNKO—长锦商船",
            ports:'上海，蛇口，赤湾'
        },
        {
            vesselName:"SWIR—太古轮船",
            ports:'上海，蛇口，赤湾，盐田'
        },
        {
            vesselName:"TSC/TSL—德翔海运",
            ports:'上海，蛇口，赤湾'
        },
        {
            vesselName:"BAL-博亚国际海运有限公司",
            ports:'上海，蛇口，赤湾，盐田'
        },
        {
            vesselName:"UAF-非洲联合海运",
            ports:'上海，蛇口，大铲湾，盐田，南沙'
        },
        {
            vesselName:"FPL-西马泰克",
            ports:'赤湾，南沙'
        },
        {
            vesselName:"TFL-致远航运",
            ports:'蛇口，赤湾'
        },
        {
            vesselName:"HDS-伊朗国航",
            ports:'盐田，南沙'
        },
        {
            vesselName:"CSL-晶品航运",
            ports:'赤湾，盐田，南沙'
        },
        {
            vesselName:"BEN-边行",
            ports:'南沙'
        },
        {
            vesselName:"SMH—司马泰海运",
            ports:'上海，蛇口，赤湾'
        },

    ]
}